document.addEventListener('DOMContentLoaded', function (evt) {
    var disable = document.querySelectorAll('.-disable-right-click');
    for (var i = 0; i < disable.length; i++) {
        disable[i].oncontextmenu = function () { return false };
    }
});